import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedReimaginedIdrIndexRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const [loansData, dataSourceInfo] = await Promise.all([
      this.reimaginedData.fetchLoansData(),
      this.reimaginedData.getDataSourceInfo(),
    ]);

    return {
      ...loansData,
      dataSourceInfo,
    };
  }
}
